import {FC} from 'react'
import clsx from 'clsx'
import { toAbsoluteUrl} from '../../../helpers'
import { useAuth } from '../../../../app/contexts/auth.context'
import Moment from 'react-moment'
import {Link} from 'react-router-dom'


const itemClass = '',
  userAvatarClass = 'symbol-30px symbol-md-35px'

const Topbar: FC = () => {
  const date = new Date().toString();
  const {currentUser} = useAuth();

  return (
    <div className='d-flex align-items-stretch flex-shrink-0 w-100 justify-content-between' id='kt_topbar'>
      <div className={clsx('d-flex align-items-center', itemClass)} id='kt_header_user_menu_toggle'>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <span>
          <Link to='/dashboard' className='d-flex align-items-center'>
            <img
              src={toAbsoluteUrl('/media/ATR/images/M-connect.png')}
              alt='logo'
              className='h-38px logo'
            />
          </Link>
          </span>
        </div>
        <span style={{'fontSize':'16px', 'fontWeight': 'bold', 'marginTop': '8px'}}> - Client </span>
      </div>
      <div className='d-flex topbar-data'>
          <div className="user-info d-flex">
            <span className='username'>
                {currentUser?.agency_agencyName}
            </span>
            <span className='topbar-divider ms-4'> </span>
              <span className='topbar-date ms-3'><Moment format='MM/DD/YYYY'>{new Date(date).toISOString()}</Moment></span>
            <span className='topbar-divider ms-4'> </span>
          </div>
      </div>
    </div>
  )
}

export {Topbar}
